import { fork } from 'redux-saga/effects';
import auth from './Auth';
import home from './Home';
import registrationViewer from './RegistrationViewer';
import adminSettingBooth from './AdminSettingBooth';
import adminSettingSeminarRoom from './AdminSettingSeminarRoom';
import registrationOrganizer from './RegistrationOrganizer';
import eventManagement from './EventManagement';
import adminCompanyManagement from './AdminCompanyManagement';
import organizerManagement from './OrganizerManagement';
import viewerManagement from './ViewerManagement';
import companyManagementOrganizer from './CompanyManagementOrganizer';
import seminarManagementOrganizer from './SeminarManagementOrganizer';
import seminarManagementViewer from './SeminarManagementViewer';
import productMangement from './ProductManagement';
import Options from './Options';
import productListOnDisplay from './ProductListOnDisplay';
import OrganizerList from './OrganizerList';
import OrganizerPosterList from './OrganizerPosterList';
import SeminarRegisteredManagermentViewer from './SeminarRegisteredManagermentViewer';
import RegisterSeminarManagerment from './RegisterSeminarManagerment';
import FavoriteCompanies from './FavoriteCompanies';
import SurveryManagement from './SurveyManagement';
import AdvertisementManagement from './AdvertisementManagement';
import QAListManagerment from './QAListManagerment';
import VisitHistoryManagement from './VisitHistoryManagement';
import SeminarManagement from './SeminarManagement';
import Mail from './Mail';
import LiveStreamManagement from './LiveStreamManagement';
import outerServerMail from './OuterServerMail';
import adminSettingShoppingCart from './AdminSettingShoppingCart';
import settingSellProductOrganizer from './SettingSellProductOrganizer';
import adminOrderProductPaymentManagement from './AdminOrderProductPaymentManagement';
import adminListRegisterLiveStream from './AdminListRegisterLiveStream';
import CartViewer from './CartViewer';
import SettingProductCompany from './SettingProductCompany';
import AdminSettingCustom from './AdminSettingCustom';
import SettingLanguage from './SettingMultiLanguage';
import locate from './locale';

export default function* root() {
    yield fork(home);
    yield fork(auth);
    yield fork(registrationViewer);
    yield fork(adminSettingBooth);
    yield fork(eventManagement);
    yield fork(adminSettingSeminarRoom);
    yield fork(registrationOrganizer);
    yield fork(organizerManagement);
    yield fork(adminCompanyManagement);
    yield fork(viewerManagement);
    yield fork(companyManagementOrganizer);
    yield fork(seminarManagementOrganizer);
    yield fork(seminarManagementViewer);
    yield fork(productMangement);
    yield fork(Options);
    yield fork(productListOnDisplay);
    yield fork(OrganizerList);
    yield fork(OrganizerPosterList);
    yield fork(SeminarRegisteredManagermentViewer);
    yield fork(RegisterSeminarManagerment);
    yield fork(FavoriteCompanies);
    yield fork(SurveryManagement);
    yield fork(AdvertisementManagement);
    yield fork(QAListManagerment);
    yield fork(VisitHistoryManagement);
    yield fork(SeminarManagement);
    yield fork(Mail);
    yield fork(LiveStreamManagement);
    yield fork(outerServerMail);
    yield fork(adminSettingShoppingCart);
    yield fork(settingSellProductOrganizer);
    yield fork(adminOrderProductPaymentManagement);
    yield fork(adminListRegisterLiveStream);
    yield fork(CartViewer);
    yield fork(SettingProductCompany);
    yield fork(AdminSettingCustom);
    yield fork(SettingLanguage);
    yield fork(locate);
}
